import { useEffect } from "react";
import { useForm } from "react-hook-form";
import Input from "../../components/form-controls/Input";
import TextArea from "../../components/form-controls/TextArea";
import InvalidFeedback from "../../components/InvalidFeedback";
import { useTranslation } from "react-i18next";


function FormMessagePartial({ data, onClose }) {
    const { t } = useTranslation();
    const interactiveType = {
        header: { es: '' },
        body: { es: '' },
        action: {
            button: { es: '' }, // Obligatorio si es lista
            sections: {
                title: { es: '' }, // Obligatorio si es lista
                rows: [
                    {
                        type: '',
                        text: { es: '' },
                        url: '',
                    }
                ]
            }
        },
        footer: { es: '' },
    }
    
    const defaultValues = {
        type: '',
        text: { es: '' },
        interactive: interactiveType,
    }

    const { control, register, unregister, watch, getValues, setValue, reset, handleSubmit, formState: { errors, isValid } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const typeMessage = watch('type')
    const rows = watch('interactive.action.sections.rows');

    const removeRow = (index: number) => {
        let rowsCopy = structuredClone(rows)
        rowsCopy = rowsCopy.filter((_: any, i: number) => i !== index);

        setValue('interactive.action.sections.rows', rowsCopy)
    }

    const addRow = () => {
        let rowsCopy = structuredClone(rows)
        rowsCopy.push({
            type: '',
            text: { es: '' },
            url: '',
        });

        setValue('interactive.action.sections.rows', rowsCopy)
    }

    const submit = (data: any) => {
        let { type, text, interactive } = data;

        interactive.action.sections.rows = interactive.action.sections.rows.map( row => {
            return row.type === 'TEXT' ? row.text: row;
        })

        let params = {
            type,
            [type === 'TEXT' ? 'text': 'interactive']: type === 'TEXT' ? text: interactive
        }
        onClose(params)
    }

    useEffect(() => {
        if(!data) {
            setValue('interactive.action.button.es', '')
            setValue('interactive.action.sections.title.es', '')
            setValue('interactive.action.sections.rows', [{
                type: '',
                text: { es: '' },
                url: '',
            }])
        }
    }, [typeMessage])

    useEffect(() => {
        if(data) {
            if(data.interactive) {
                data.interactive.action.sections.rows = data.interactive.action.sections.rows.map( btn => {
                    return {
                        type: btn.type? btn.type: 'TEXT',
                        text: btn.type? btn.text: btn,
                        url: btn.type? btn.url: '',
                    }
                })
            }

            reset(Object.assign(defaultValues, data ))
        }
    }, [data])
    

    return (
        <div className='push-view view-node show'>
            <div className="card-header  d-flex align-items-center">
                <button type="button" className="btn btn-ghost-light btn-icon ml-negative-1" style={{ height: 'auto' }} onClick={() => onClose()}>
                    <i className="bi-chevron-left text-dark"></i>
                </button>
                <h3 className="card-header-title">Mensaje</h3>
            </div>

            <div className="card-body">

                <div className="mb-3">
                    <label className="form-label" >Tipo de validación *</label>
                    <select className={'form-control ' + (errors?.type ? 'is-invalid' : '')}  {...register('type', { required: true })}>
                        <option disabled value={''}>Elija una opción</option>
                        <option value={'TEXT'}>Texto</option>
                        <option value={'LIST'}>Lista</option>
                        <option value={'BUTTONS'}>Respuestas rápidas</option>
                    </select>
                    <InvalidFeedback error={errors.type} />
                </div>

                {
                    typeMessage === 'TEXT' && (
                        <div className="mb-3">
                            <label className="form-label" >Feedback *</label>
                            <textarea className={'form-control ' + (errors.text?.es ? 'is-invalid' : '')} placeholder="Mensaje" rows={4} {...register('text.es', { required: true, maxLength: { value: 1024, message: '1024' } })}></textarea>

                            <InvalidFeedback error={errors.text?.es} />
                            <div className="form-text mt-1 text-end">{watch('text.es').length}/1024</div>
                        </div>
                    )
                }
                {
                    (typeMessage === 'LIST' || typeMessage === 'BUTTONS') && (
                        <>
                            <div className="mb-3">
                                <Input 
                                    label='Cabecera' 
                                    errors={errors.interactive?.header?.es} 
                                    maxLength={60}
                                    currentLength={watch('interactive.header.es').length}
                                    {...register('interactive.header.es', {  maxLength: { value: 60, message: '60' } })} 
                                />
                            </div>

                            <div className="mb-3">
                                <TextArea
                                    label='Mensaje *'
                                    errors={errors.interactive?.body?.es}
                                    value={watch('interactive.body.es').length}
                                    counter={1024}
                                    {...register('interactive.body.es', { required: true, maxLength: { value: 1024, message: '1024' } })} 
                                />
                            </div>

                            {
                                typeMessage === 'LIST' && (
                                    <>
                                        <div className="mb-3">
                                            <Input 
                                                label='Nombre de botón *' 
                                                errors={errors.interactive?.action?.button?.es} 
                                                maxLength={20}
                                                currentLength={watch('interactive.action.button.es').length}
                                                {...register('interactive.action.button.es', { required: true, maxLength: { value: 20, message: '20' } })} />
                                        </div>
                                        <div className="mb-3">
                                            <Input 
                                                label='Encabezado de lista *' 
                                                errors={errors.interactive?.action?.sections?.title?.es} 
                                                maxLength={20}
                                                currentLength={watch('interactive.action.sections.title.es').length}
                                                {...register('interactive.action.sections.title.es', { required: true, maxLength: { value: 20, message: '20' } })} />
                                        </div>
                                    </>
                                )
                            }
                            

                            {
                                rows.map((row, index) => (
                                    <div className="" key={index}>
                                        <span className="divider-center">{typeMessage === 'LIST' ? `Texto de opción ${index + 1} *` : `Texto de respuesta rápida ${index + 1} *`}</span>
                                        <div>
                                            <div>
                                                <div className="d-flex align-items-center mb-3">
                                                    {/* <label className="form-label">{typeMessage === 'LIST' ? `Texto de opción ${index + 1} *` : `Texto de respuesta rápida ${index + 1} *`}</label> */}
                                                    {/* {
                                                        index > 0 && <button className="btn btn-soft-danger ms-auto" type="button" onClick={() => removeRow(index)}><i className="bi-x-lg"></i></button>
                                                    } */}
                                                    {/* {
                                                        index > 0 && <button className="btn btn-soft-danger btn-sm ms-auto" type="button" onClick={() => removeRow(index)}><i className="bi-x-lg"></i></button>
                                                    } */}
                                                </div>
                                                
                                                <div className="mb-3">
                                                    <select className={'form-control ' + (errors.interactive?.action?.sections?.rows?.[index]?.type ? 'is-invalid' : '')}  {...register(`interactive.action.sections.rows.${index}.type`, { required: true })}>
                                                        <option disabled value={''}>Tipo de botón {index + 1} *</option>
                                                        <option value={'TEXT'}>Texto</option>
                                                        <option value={'URL'}>URL</option>
                                                    </select>
                                                </div>
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        className={'form-control ' + (errors.interactive?.action?.sections?.rows?.[index]?.text?.es ? 'is-invalid' : '')}
                                                        placeholder={typeMessage === 'LIST' ? `Texto de opción ${index + 1}` : `Texto de botón ${index + 1}`}
                                                        defaultValue={getValues(`interactive.action.sections.rows.${index}.text.es`)}
                                                        {...register(`interactive.action.sections.rows.${index}.text.es`, { required: true, maxLength: { value: 20, message: '20' } })}
                                                    />
                                                    {/* {
                                                        index > 0 && <button className="btn btn-soft-danger" type="button" onClick={() => removeRow(index)}><i className="bi-x-lg"></i></button>
                                                    } */}
                                                    <InvalidFeedback error={errors.interactive?.action?.sections?.rows?.[index]?.text?.es} />
                                                </div>

                                                <div className="form-text mt-1 text-end">{watch(`interactive.action.sections.rows.${index}.text.es`)?.length}/20</div>

                                                {
                                                    getValues(`interactive.action.sections.rows.${index}.type`) === 'URL' && (
                                                        <div className="mb-3">
                                                            <input
                                                                type="text"
                                                                className={'form-control ' + (errors.interactive?.action?.sections?.rows?.[index]?.url ? 'is-invalid' : '')}
                                                                placeholder="URL *"
                                                                defaultValue={getValues(`interactive.action.sections.rows.${index}.url`)}
                                                                {...register(`interactive.action.sections.rows.${index}.url`, { required: true })}
                                                            />
                                                            <InvalidFeedback error={errors.interactive?.action?.sections?.rows?.[index]?.url} />
                                                        </div> 
                                                    )
                                                }

                                                {
                                                    index > 0 && <div className="d-grid mb-3"><button className="btn btn-soft-danger btn-sm w-full" type="button" onClick={() => removeRow(index)}><i className="bi-x-lg"></i> Borrar</button></div>
                                                }
                                                
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                            

                            <div className="d-grid gap-2 my-3">
                                <button
                                    type="button"
                                    className="btn btn-secondary btn-sm"
                                    onClick={addRow}
                                    disabled={typeMessage === 'LIST' ? getValues(`interactive.action.sections.rows`).length >= 10 : getValues(`interactive.action.sections.rows`).length >= 3}
                                >+ {typeMessage === 'LIST' ? `Agregar opción` : `Agregar botón`}</button>
                            </div>
                            
                            <div className="mb-3">
                                <Input 
                                    label='Pie ' 
                                    errors={errors.interactive?.footer?.es} 
                                    maxLength={60}
                                    currentLength={watch('interactive.footer.es').length}
                                    {...register('interactive.footer.es', {  maxLength: { value: 60, message: '60' } })} />
                            </div>
                        </>
                    )
                }

                <div className="d-grid gap-2 mt-5  mb-3 ">
                    <button type="button" className="btn btn-primary" onClick={handleSubmit(submit)} disabled={!isValid}>{t('btn-save')}</button>
                </div>

            </div>
        </div>
    )
}
export default FormMessagePartial